<template>
  <div class="home">
    <div style="text-align: right; padding: 10px">
      <el-button
        type="primary"
        icon="el-icon-switch-button"
        @click="signOut"
        plain
        >Sign Out</el-button
      >
    </div>
    <div class="tenants">
      <el-row :gutter="12">
        <el-col :span="24" v-for="(item, i) in listData" :key="i">
          <el-button
            icon="el-icon-edit-outline"
            size="medium"
            type="primary"
            plain
            @click="switchTenants(item)"
            >{{ item.name }}</el-button
          >
        </el-col>
        <!-- <el-col :span="24" v-if="listData.length > 1">
          <i style="cursor: pointer" class="el-icon-sunrise-1"></i>
          <el-button @click="homeRouter" size="medium">查看所有基地</el-button>
        </el-col> -->
        <el-col :span="24" v-if="listData.length < 1">
          <i style="cursor: pointer" class="el-icon-sunrise-1"></i>
          <el-button size="medium">未授权租户</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import API from "@/utils/api";
import router from "../../router";
export default {
  name: "home",
  data() {
    return {
      listData: [],
    };
  },
  mounted() {
    // 初始化
    this.init();
  },
  methods: {
    signOut() {
      localStorage.removeItem("user_session");
      router.push("/login");
    },
    init() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }

      API.getTenants()
        .then((res) => {
          if (res.success == true) {
            var list = res["list"];
            this.listData = list;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          this.$message.error("网络错误,数据查询失败");
        });
    },
    homeRouter() {
      router.push("/home?type=all");
    },
    switchTenants(item) {
      var params = { tenantUUID: item["uuid"] };
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
      }
      API.switchTenants(params)
        .then((res) => {
          if (res.success == true) {
            var bean = res.value;
            user["token"] = bean.token;
            user["tenant"] = bean["tenant"]["name"];
            localStorage.setItem("user_session", JSON.stringify(user));
            router.push("/home");
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          this.$message.error("网络错误,数据查询失败");
        });
    },
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./home.css'></style>



// WEBPACK FOOTER //
// src/pages/home/tenants.vue